import { Box } from '@mui/material';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE_PATH } from '../../routers/RoutPath';

const LinkExpire = () => {
  const navigate = useNavigate();

  return (
    <Box className="default-page mt-32">
      <CustomTypography id="link-expire-title" variant="h3" className="pb-12">
        Link Expired
      </CustomTypography>
      <CustomTypography
        id="link-expire-message"
        variant="body2"
        color="textSecondary"
        className="pb-32"
      >
        The password reset link has expired or is no longer valid. Please
        request a new password reset link.
      </CustomTypography>
      <Box className="mt-24">
        <CustomButton
          id="back-to-login"
          variant="contained"
          size="large"
          onClick={() => navigate(LOGIN_ROUTE_PATH)}
        >
          Back to Login
        </CustomButton>
      </Box>
    </Box>
  );
};

export default LinkExpire;
